export const GET_CONTENT = 'GET_CONTENT';
export const GET_DIAGNOSIS_USER_PROFILE = 'GET_DIAGNOSIS_USER_PROFILE';
export const GET_HAIR_DIAGNOSIS = 'GET_HAIR_DIAGNOSIS';
export const GET_NEWS_AND_EVENT = 'GET_NEWS_AND_EVENT';
export const GET_NEWS_AND_EVENTS = 'GET_NEWS_AND_EVENTS';
export const GET_INSPIRATION_ARTICLES = 'GET_INSPIRATION_ARTICLES';
export const GET_STYLES = 'GET_STYLES';
export const GET_RANGE_SKIN_BODY_CARE = 'GET_RANGE_SKIN_BODY_CARE';
export const GET_RANGE_HAIR_CARE = 'GET_RANGE_HAIR_CARE';
export const GET_RANGE_HAIR_COLOR = 'GET_RANGE_HAIR_COLOR';
export const GET_RANGE_MAKE_UP = 'GET_RANGE_MAKE_UP';
export const GET_RANGE_MENS = 'GET_RANGE_MENS';
export const GET_RANGE_PERM = 'GET_RANGE_PERM';
export const GET_RANGE_STYLING = 'GET_RANGE_STYLING';
export const GET_SEARCHABLES = 'GET_SEARCHABLES';
export const GET_SEMINAR = 'GET_SEMINAR';
export const GET_SEMINAR_SPECIFICS = 'GET_SEMINAR_SPECIFICS';
export const GET_SITE_OPTIONS = 'GET_SITE_OPTIONS';
export const GET_STYLIST_TOOL = 'GET_STYLIST_TOOL';
export const GET_USER_DIAGNOSIS = 'GET_USER_DIAGNOSIS';
export const GET_SALON_CONSULTAION_SITE_OPTIONS = 'GET_SALON_CONSULTAION_SITE_OPTIONS';
export const GET_HOME_CARE_ITEM_LIST = 'GET_HOME_CARE_ITEM_LIST';
export const GET_SALON_CONSULTATION_TOP = 'GET_SALON_CONSULTATION_TOP';
export const GET_SUBLIMIC_HOME = 'GET_SUBLIMIC_HOME';
export const GET_SALON_SOLUTION_LIST = 'GET_SALON_SOLUTION_LIST';
export const GET_SALON_SETTING = 'GET_SALON_SETTING';
export const GET_CUSTOMER_SEARCH = 'GET_CUSTOMER_SEARCH';
export const GET_SPAUTH_SETTING = 'GET_SPAUTH_SETTING';
export const UPDATE_DIAGNOSIS_RESULT = 'UPDATE_DIAGNOSIS_RESULT';
export const RESET_DIAGNOSIS_RESULT = 'RESET_DIAGNOSIS_RESULT';
export const GET_CUSTOMER_REGISTRATION = 'GET_CUSTOMER_REGISTRATION';
export const PUT_SETTING = 'PUT_SETTING';
export const SET_SCALPCAMERA_PIN_CODE = 'SET_SCALPCAMERA_PIN_CODE';
export const RESET_SCALPCAMERA_PIN_CODE = 'RESET_SCALPCAMERA_PIN_CODE';
// TODO: コンテントタイプ「beautyConsultation」を「beautyContents」と差し替える
export const GET_BEAUTY_CONSULTATION = 'GET_BEAUTY_CONSULTATION';
export const GET_BEAUTY_CONTENTS = 'GET_BEAUTY_CONTENTS';

export const GET_CUSTOMER_PROFILE = 'GET_CUSTOMER_PROFILE';
export const GET_SALON_VISITS = 'GET_SALON_VISITS';
export const SAVE_SALON_VISITS = 'SAVE_SALON_VISITS';
export const RESET_SALON_VISITS = 'RESET_SALON_VISITS';
export const GET_HOME_CARE_ITEM_CONCERNS = 'GET_HOME_CARE_ITEM_CONCERNS';

export const MAKE_USER_CURRENT = 'MAKE_USER_CURRENT';

export const RESET_USER_DIAGNOSIS = 'RESET_USER_DIAGNOSIS';

export const SAVE_TEMPORARY_DIAGNOSIS_USER = 'SAVE_TEMPORARY_DIAGNOSIS_USER';
export const SAVE_DIAGNOSIS_USER = 'SAVE_DIAGNOSIS_USER';
export const SAVE_NEW_SALON_VISIT = 'SAVE_NEW_SALON_VISIT';
export const GET_USER = 'GET_USER';
export const CLEAR_USER = 'CLEAR_USER';

export const GET_USER_SURVEY = 'GET_USER_SURVEY';
export const GET_SCALP_CAMERA = 'GET_SCALP_CAMERA';
export const GET_STYLIST_DIAGNOSIS = 'GET_STYLIST_DIAGNOSIS';
export const GET_SUBLIMIC_DIAGNOSIS_RESULT = 'GET_SUBLIMIC_DIAGNOSIS_RESULT';
export const GET_SUBLIMIC_DIAGNOSIS_LOGICS = 'GET_SUBLIMIC_DIAGNOSIS_LOGICS';
export const RESET_SUBLIMIC_DIAGNOSIS_LOGICS = 'RESET_SUBLIMIC_DIAGNOSIS_LOGICS';

export const UPDATE_LOCALE_COPY = 'UPDATE_LOCALE_COPY';
export const UPDATE_SCREEN_SIZE = 'UPDATE_SCREEN_SIZE';
export const UPDATE_SCALP_CAMERA_OPTION = 'UPDATE_SCALP_CAMERA_OPTION';
export const UPDATE_SCALP_CAMERA_STATUS = 'UPDATE_SCALP_CAMERA_STATUS';

export const SAVE_SUBLIMIC_USER_SURVEY = 'SAVE_SUBLIMIC_USER_SURVEY';
export const SAVE_SUBLIMIC_STYLIST_DIAGNOSIS = 'SAVE_SUBLIMIC_STYLIST_DIAGNOSIS';
export const RESET_SUBLIMIC_DIAGNOSIS = 'RESET_SUBLIMIC_DIAGNOSIS';

export const SAVE_BEAUTY_CONSULTATION_DIAGNOSIS_USER_DATA = 'SAVE_BEAUTY_CONSULTATION_DIAGNOSIS_USER_DATA';
export const SAVE_BEAUTY_CONSULTATION_DIAGNOSIS = 'SAVE_BEAUTY_CONSULTATION_DIAGNOSIS';

export const GET_SCALPCAMERA_PIN_CODE = 'GET_SCALPCAMERA_PIN_CODE';
export const RESET_SCALPCAMERA_DIAGNOSIS = 'RESET_SCALPCAMERA_DIAGNOSIS';

export const GET_SCALPCAMERA_DIAGNOSIS_RESULT = 'GET_SCALPCAMERA_DIAGNOSIS_RESULT';
export const SAVE_SUBLIMIT_USER_DATA = 'SAVE_SUBLIMIT_USER_DATA';
export const GET_SALON_VISIT_TOOL = 'GET_SALON_VISIT_TOOL';
export const GET_SCALP_CAMERA_GUIDE = 'GET_SCALP_CAMERA_GUIDE';



// WEBPACK FOOTER //
// ./src/redux/constants.js